exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".association-logo{padding-top:50%;width:100%;background-position:50%;background-size:contain}", ""]);

// exports
